export const drawerWidth = "221px";
// Set drawer z-index for easier calculation
export const drawerZIndex = 1300;
